var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteEyeIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4999 3.75017L1.49992 14.2502L1.06982 13.6357L16.0698 3.13574L16.4999 3.75017Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4224 6.11962C15.5132 7.16605 16.1833 8.24447 16.4026 8.62478C16.5365 8.85683 16.5365 9.14273 16.4026 9.37478C15.7576 10.4998 13.3501 14.1448 9.20255 14.2498H9.01505C7.3213 14.2498 5.90539 13.6533 4.77664 12.8716L7.3692 11.0568C7.81708 11.4124 8.38376 11.6248 9.00005 11.6248C10.4498 11.6248 11.6251 10.4495 11.6251 8.99978C11.6251 8.71024 11.5782 8.43164 11.4916 8.17117L14.4224 6.11962ZM13.8472 5.60673C12.589 4.56671 10.895 3.68665 8.79755 3.74978C4.65005 3.85478 2.25005 7.49978 1.59755 8.62478C1.46358 8.85683 1.46358 9.14273 1.59755 9.37478C1.85352 9.81765 2.7126 11.2114 4.14855 12.3958L6.84937 10.5052C6.55047 10.079 6.37505 9.55988 6.37505 8.99978C6.37505 7.55003 7.5503 6.37478 9.00005 6.37478C9.88968 6.37478 10.6759 6.81733 11.1507 7.49429L13.8472 5.60673ZM8.74289 10.0953C8.82548 10.1146 8.91157 10.1248 9.00005 10.1248C9.57622 10.1248 10.0512 9.69165 10.1172 9.13322L8.74289 10.0953ZM9.92175 8.35456L8.07832 9.64496C7.95023 9.4623 7.87505 9.23982 7.87505 8.99978C7.87505 8.37846 8.37873 7.87478 9.00005 7.87478C9.38132 7.87478 9.71828 8.06444 9.92175 8.35456Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEyeIconClose);
export default __webpack_public_path__ + "static/media/whiteEyeIconClose.09a7ec43d4615203d4ce81cf9a9917d4.svg";
export { ForwardRef as ReactComponent };